<template>
  <div id="view-login">
    <div id="login-container">
      <div
        class="bg-dark px-3 py-2 mb-3 rounded shadow-sm d-flex justify-content-between align-items-center"
      >
        <img src="@/assets/jkr-logo.png" class="logo" />
        <p class="mb-0 fw-bold fs-4">CMS</p>
      </div>
      <div class="bg-dark p-4 rounded shadow-sm">
        <div class="mb-3">
          <label for="login.email" class="form-label">Email</label>
          <input
            type="email"
            class="form-control"
            id="login.email"
            placeholder="name@example.com"
            v-model="models.identifier"
            @keypress.enter="doLogin()"
          />
        </div>
        <div class="mb-4">
          <label for="login.password" class="form-label">Password</label>
          <input
            type="password"
            class="form-control"
            id="login.password"
            placeholder="*****************"
            v-model="models.password"
            @keypress.enter="doLogin()"
          />
        </div>
        <div>
          <button class="btn btn-primary w-100" @click="doLogin()">
            Sign In
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
  data() {
    return {
      models: {
        identifier: "",
        password: "",
      },
    };
  },
  methods: {
    triggerErrorPopup(text) {
      Swal.fire({
        title: `<h5>${text || "Invalid email or password"}</h5>`,
        icon: "error",
      });
    },
    async doLogin() {
      if (!this.models.identifier || !this.models.password) {
        this.triggerErrorPopup();
      } else {
        this.Helper.toggleLoadingSpinner(true);

        const [call, error] = await this.Helper.handlePromise(
          this.API.post("auth/local", this.models)
        );

        if (error) {
          console.error(error);

          this.triggerErrorPopup();
        } else {
          if (call.data.user.isCmsUser) {
            localStorage.setItem("token", call.data.jwt);

            localStorage.setItem(
              "user",
              JSON.stringify({
                _id: call.data.user._id,
                id: call.data.user.id,
                contractor: call.data.user.contractor,
                email: call.data.user.email,
                name: call.data.user.name,
                username: call.data.user.username,
                districts: call.data.user.districts || [],
                role: call.data.user.role ? call.data.user.role.name : "",
              })
            );

            this.$nextTick(() => {
              if (this.$route.query.returnUrl) {
                this.$router.push(this.$route.query.returnUrl);
              } else {
                this.$router.push("/");
              }
            });
          } else {
            this.triggerErrorPopup(
              "You are not authorized to access this site.<br/>Please contact admin to enable your account."
            );
          }
        }

        this.Helper.toggleLoadingSpinner(false);
      }
    },
  },
};
</script>